import { Decrypt } from "@/lib/crypto";


function hasPermission(key) {


    return true; // @mohiuddin  just comment out this line to get all permission for development! 

    const tags = localStorage.getItem("tags");

    if (tags) {
        const permission = Decrypt(tags) || [];

        // console.log(permission)

        if (Array.isArray(key)) {
            return key.some(k => permission.includes(k));
        }

        return permission.includes(key);
    }

    return false;

}

export default hasPermission;